import { useCallback, useEffect, useState } from "react";
import { useAuth } from "./useAuth";
import { useErrorHandler } from "./useErrorHandler";
import { TModelCounters } from "../filters/deprecated.types";
import { useCommonFilters } from "./useCommonFilters";
import useModel from "./useModel";
import { ModelNames } from "../models";
import partnerQuery from "../queries/partners";
import partnersFilters from "../filters/partners";

export const initialPartnerCounts = (): TModelCounters =>
  partnersFilters.map(({ name, value, nestedFilters }) => ({
    value,
    name,
    count: 0,
    nested:
      nestedFilters &&
      nestedFilters.map(({ name, value }) => ({
        name,
        value,
        count: 0,
      })),
  }));

const usePartnerCounters = () => {
  const { isLoggedIn } = useAuth();
  const { errorHandler } = useErrorHandler();
  const commonFilters = useCommonFilters();
  const partnersModel = useModel(ModelNames.PARTNERS);

  const [statusCounters, setStatusCounters] = useState<TModelCounters>(
    initialPartnerCounts()
  );

  const queryPartnerCounts = useCallback(async (filter: any) => {
    try {
      const count = await partnersModel.count(filter);
      return count;
    } catch (error) {
      errorHandler(new Error("Erro ao carregar contadores de parceiros"));
      return 0;
    }
  }, []);

  const countDocuments = async () => {
    partnersFilters.forEach(
      async ({ value: role, nestedFilters }, roleIndex) => {
        nestedFilters?.forEach(async ({ value: status }, statusIndex) => {
          const statusCount = await queryPartnerCounts(
            partnerQuery({
              ...commonFilters,
              selectedStatusList: [role, status],
            })
          );
          setStatusCounters((prev: typeof statusCounters) => [
            ...prev.slice(0, roleIndex),
            {
              ...prev[roleIndex],
              nested: nestedFilters && [
                ...prev[roleIndex].nested!.slice(0, statusIndex),
                {
                  ...prev[roleIndex].nested![statusIndex],
                  count: statusCount,
                },
                ...prev[roleIndex].nested!.slice(statusIndex + 1),
              ],
            },
            ...prev.slice(roleIndex + 1),
          ]);
        });
        const roleCount = await queryPartnerCounts(
          partnerQuery({
            ...commonFilters,
            selectedStatusList: [role],
          })
        );
        setStatusCounters((prev: typeof statusCounters) => [
          ...prev.slice(0, roleIndex),
          {
            ...prev[roleIndex],
            count: roleCount,
          },
          ...prev.slice(roleIndex + 1),
        ]);
      }
    );
  };

  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }
    countDocuments();
  }, [isLoggedIn]);

  return statusCounters;
};

export default usePartnerCounters;
